<template>
  <div class="my-collection-container">
    <!-- <div class="custom-header">
        <h2>My Knowits</h2>
      </div> -->

    <!-- Fixed tabs section -->
    <!-- <div class="tabs-container">

        <el-tabs v-model="activeTab" class="demo-tabs" @tab-click="handleTabClick">
          
          <el-tab-pane label="Published" name="published"></el-tab-pane>
          <el-tab-pane label="Drafts" name="drafts"></el-tab-pane>
          <el-tab-pane label="Collections" name="created"></el-tab-pane>
          <el-tab-pane label="Bundles" name="bundles"></el-tab-pane>

        </el-tabs>
      </div> -->

    <!-- Scrollable content section -->
    <!-- <div class="content-container"> -->
    <div class="tabs-header">
      <el-tabs v-model="activeTab" class="demo-tabs" @tab-click="handleTabClick">
        <!-- My Posts/Stacks tab -->
        <el-tab-pane label="My Stacks" name="posts" v-if="['Basic', 'Pro', 'Premium', 'Supreme'].includes(creator_functionality_level)">
          <div class="posts-tab-container">
            <div class="posts-controls">
              <div class="filter-widget">
                <el-radio-group v-model="selectedGroup" size="small">
                  <el-radio-button label="all">All Stacks</el-radio-button>
                  <el-radio-button label="private">Unlisted</el-radio-button>
                  <el-radio-button label="public">Public</el-radio-button>
                </el-radio-group>
              </div>
              <div class="search-controls">
                <el-input
                  v-model="searchQuery"
                  placeholder="Search stacks..."
                  size="small"
                  @keyup.enter="handleSearch"
                  clearable
                  style="width: 200px; margin-right: 10px;"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="goToNewKnowit" size="small">
                  <i class="el-icon-plus"></i> New Stack
                </el-button>
              </div>
            </div>

            <div class="posts-grid-container">
              <Post v-for="post in searchFilteredPosts" :key="post.id || post._id?.$oid || post._id?.$id || Math.random()"
                :post="post || {}"
                :groupOptions="[]"
                @edit="editDraft"
                @updatePostGroup="updatePostGroup"
                @like="handleLike"
                @comment="handleComment"
                @login-required="showLoginDialog"
                class="grid-item" />
            </div>

            <div v-if="searchFilteredPosts.length === 0" class="empty-state">
              <p>{{ emptyStacksMessage }}</p>
              <el-button type="primary" @click="$router.push('/new-knowit')">
                Create Your First Stack
              </el-button>
            </div>
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="My Courses"
          v-if="['Basic', 'Pro', 'Premium', 'Supreme'].includes(creator_functionality_level)" name="created">
          <div class="posts-container">
            <div class="tab-header">
              <div class="view-mode-selector">
                <el-radio-group v-model="viewMode" size="small">
                  <el-radio-button label="grid">
                    <i class="el-icon-s-grid"></i>
                  </el-radio-button>
                  <el-radio-button label="list">
                    <i class="el-icon-s-operation"></i>
                  </el-radio-button>
                </el-radio-group>
              </div>
              <div class="search-controls">
                <el-input
                  v-model="searchQuery"
                  placeholder="Search courses..."
                  size="small"
                  @keyup.enter="handleSearch"
                  clearable
                  style="width: 200px; margin-right: 10px;"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="handleNewCollection">
                  + New Course
                </el-button>
              </div>
            </div>
            <el-skeleton :rows="3" animated v-if="createdLoading" style="padding: 20px;" />
            <template v-else>
              <div v-if="viewMode === 'list'" class="list-container">
                <Collection v-for="collection in searchFilteredCollections"
                  :key="collection._id && (collection._id.$oid || collection._id.$id) ? (collection._id.$oid || collection._id.$id) : collection.id || collection._id || Math.random()"
                  :collection="collection || {}" @like="handleLike" />
              </div>
              <div v-else class="grid-container">
                <CollectionSimpleCard v-for="collection in searchFilteredCollections"
                  :key="collection._id && (collection._id.$oid || collection._id.$id) ? (collection._id.$oid || collection._id.$id) : collection.id || collection._id || Math.random()"
                  :collection="collection || {}"
                  @click="goToCollection((collection._id && (collection._id.$oid || collection._id.$id)) ? (collection._id.$oid || collection._id.$id) : (collection.id || ''))"
                   />
              </div>
              <div v-if="searchFilteredCollections.length === 0" class="empty-state">
                <p>You haven't created any Course yet.</p>
                <el-button type="primary" @click="$router.push('/new-collection')">
                  Create Your First Course
                </el-button>
              </div>
            </template>
          </div>
        </el-tab-pane>

        <el-tab-pane label="My Bundles" v-if="['Pro', 'Premium', 'Supreme'].includes(creator_functionality_level)"
          name="bundles">
          <div class="posts-container">
            <div class="tab-header">
              <div class="view-mode-selector">
                <el-radio-group v-model="viewMode" size="small">
                  <el-radio-button label="grid">
                    <i class="el-icon-s-grid"></i>
                  </el-radio-button>
                  <el-radio-button label="list">
                    <i class="el-icon-s-operation"></i>
                  </el-radio-button>
                </el-radio-group>
              </div>
              <div class="search-controls">
                <el-input
                  v-model="searchQuery"
                  placeholder="Search bundles..."
                  size="small"
                  @keyup.enter="handleSearch"
                  clearable
                  style="width: 200px; margin-right: 10px;"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="handleNewBundle">
                  + New Bundle
                </el-button>
              </div>
            </div>
            <el-skeleton :rows="3" animated v-if="bundlesLoading" style="padding: 20px;" />
            <template v-else>
              <template v-if="viewMode === 'list'">
                <BundleSimple v-for="bundle in searchFilteredBundles" :key="bundle._id?.$oid || bundle._id?.$id || bundle.id" :bundle="bundle || {}"
                  @click.native="handleBundleClick(bundle)"/>
              </template>
              <div v-else class="grid-container">
                <BundleSimple v-for="bundle in searchFilteredBundles" :key="bundle._id?.$oid || bundle._id?.$id || bundle.id" :bundle="bundle || {}"
                  @click.native="handleBundleClick(bundle)" />
              </div>
              <div v-if="searchFilteredBundles.length === 0" class="empty-state">
                <p>You haven't created any Knowit Bundle yet.</p>
                <el-button type="primary" @click="$router.push('/new-bundle')">
                  Create Your First Knowit Bundle
                </el-button>
              </div>
            </template>
          </div>
        </el-tab-pane>

        <el-tab-pane label="My Subscription Programs" v-if="['Basic', 'Pro', 'Premium', 'Supreme'].includes(creator_functionality_level)" name="subscription">
          <div class="posts-container">
            <div class="tab-header">
              <el-button type="primary" @click="handleNewSubscription">
                + New Subscription Program
              </el-button>
            </div>
            <el-skeleton :rows="3" animated v-if="subscriptionLoading" style="padding: 20px;" />
            <template v-else>
              <div class="subscription-grid">
                <SubscriptionProgram
                  v-for="program in subscriptionPrograms"
                  :key="program._id?.$oid || program._id?.$id"
                  :program="program"
                  @edit="editSubscription"

                />
              </div>
              <div v-if="subscriptionPrograms.length === 0" class="empty-state">
                <p>You haven't created any subscription programs yet.</p>
                <el-button type="primary" @click="handleNewSubscription">
                  Create Your First Subscription Program
                </el-button>
              </div>
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- </div> -->

    <!-- Subscription Program Dialog -->
    <el-dialog
      :title="editingSubscription ? 'Edit Subscription Program' : 'New Subscription Program'"
      :visible.sync="subscriptionDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="subscriptionForm" :rules="subscriptionRules" ref="subscriptionForm" label-width="120px">
        <el-form-item label="Name" prop="name">
          <el-input v-model="subscriptionForm.name" placeholder="Enter program name"></el-input>
        </el-form-item>
        <el-form-item label="Description" prop="description">
          <el-input type="textarea" v-model="subscriptionForm.description" placeholder="Enter program description"></el-input>
        </el-form-item>
        <el-form-item label="Recurring Period">
          <el-select v-model="subscriptionForm.recurring_period" disabled placeholder="Monthly">
            <el-option label="Monthly" value="monthly"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Price (USD)" prop="usd_price">
          <el-input-number v-model="subscriptionForm.usd_price" :min="1" :precision="2"></el-input-number>
        </el-form-item>
        <el-form-item label="Status" prop="status">
          <el-select v-model="subscriptionForm.status" placeholder="Select status">
            <el-option label="Active" value="active"></el-option>
            <el-option label="Inactive" value="inactive"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="subscriptionDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitSubscription" :loading="submitting">Submit</el-button>
      </div>
    </el-dialog>


    <!-- Login Dialog -->
    <AuthDialog 
      :visible.sync="loginDialogVisible"
      :initial-mode="'login'"
      @login-success="handleLoginSuccess"
      @update:visible="handleAuthDialogClose"
    />

    <!-- AI Dialog Drawer -->
    <el-drawer
      :visible.sync="aiDialogVisible"
      direction="rtl"
      size="80%"
      :with-header="false"
      :modal="false"
      class="ai-drawer"
    >
      <UserAIDialogue 
        :visible="aiDialogVisible"
        @update:visible="aiDialogVisible = $event"
        :context_pot="globalContextPot"
        task-type="chat"
        title="AI Assistant"
      />
    </el-drawer>

    <!-- Share Card Dialog -->
    <el-dialog
      title="Share Knowit Card"
      :visible.sync="shareCardDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="shareForm" :rules="shareRules" ref="shareForm" label-width="100px">
        <div v-if="shareCardData" class="share-card-preview">
          <h4>Card to Share:</h4>
          <div class="card-preview">
            <div class="card-title">{{ shareCardData.title || 'Untitled' }}</div>
            <div class="card-content">{{ truncateText(shareCardData.content, 100) }}</div>
          </div>
        </div>
        <el-form-item label="Recipient" prop="recipient_email">
          <el-input 
            v-model="shareForm.recipient_email" 
            placeholder="Enter recipient's email address"
            @blur="validateRecipient"
          >
          </el-input>
          <div v-if="recipientInfo" class="recipient-info">
            <i class="el-icon-user"></i>
            <span>{{ recipientInfo.user_name || recipientInfo.email }}</span>
          </div>
        </el-form-item>
        <el-form-item label="Message" prop="message">
          <el-input 
            type="textarea" 
            v-model="shareForm.message" 
            placeholder="Add a personal message (optional)"
            rows="3"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="shareCardDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="confirmShareCard" :loading="sharingCard">
          Share Card
        </el-button>
      </div>
    </el-dialog>

    <!-- Mark Button -->
    <div class="mark-button" @click="toggleAIDialog" :title="aiDialogVisible ? 'Close AI Assistant (Cmd+L)' : 'Open AI Assistant (Cmd+L)'">
      <i :class="aiDialogVisible ? 'el-icon-close' : 'el-icon-chat-line-square'"></i>
    </div>
  </div>
</template>

<script>
import Collection from '@/components/Collection.vue'
import CollectionSimpleCard from '@/components/CollectionSimpleCard.vue'
import BundleSimple from '@/components/BundleSimple.vue'
import Post from '@/components/Post.vue'
import SubscriptionProgram from '@/components/SubscriptionProgram.vue'
import AuthDialog from '@/components/AuthDialog.vue'
import SimpleCardView from '@/components/SimpleCardView.vue'
import EditCard from '@/components/EditCard.vue'
import KnowitCardList from '@/components/KnowitCardList.vue'
import UserAIDialogue from '@/components/UserAIDialogue.vue'
import { postRequest } from '@/apis/front'
import { getUserId } from '@/utils/store'

export default {
  name: 'MyKnowits',
  components: {
    Post,
    Collection,
    CollectionSimpleCard,
    BundleSimple,
    SubscriptionProgram,
    AuthDialog,
    SimpleCardView,
    EditCard,
    KnowitCardList,
    UserAIDialogue,
  },
  data() {
    return {
      selectedGroup: 'all',
      activeTab: localStorage.getItem('myKnowitsTab') || 'created',
      purchasedPosts: [],
      createdCollections: [],
      myPosts: [],
      posted: [],
      drafts: [],
      purchasedLoading: false,
      createdLoading: false,
      viewMode: localStorage.getItem('collectionViewMode') || 'list',
      bundles: [],
      bundlesLoading: false,
      subscriptionPrograms: [],
      subscriptionLoading: false,
      subscriptionDialogVisible: false,
      editingSubscription: null,
      submitting: false,
      subscriptionForm: {
        name: '',
        description: '',
        usd_price: 1,
        status: 'active',
        recurring_period: 'monthly'
      },
      subscriptionRules: {
        name: [
          { required: true, message: 'Please enter program name', trigger: 'blur' },
          { min: 3, max: 50, message: 'Length should be 3 to 50 characters', trigger: 'blur' }
        ],
        description: [
          { required: true, message: 'Please enter program description', trigger: 'blur' }
        ],
        usd_price: [
          { required: true, message: 'Please enter price', trigger: 'blur' },
          { type: 'number', min: 1, message: 'Price must be at least $1', trigger: 'blur' }
        ],
        status: [
          { required: true, message: 'Please select status', trigger: 'change' }
        ]
      },
      loginDialogVisible: false,
      // Private Cards data
      privateCards: [],
      privateCardsLoading: false,
      // AI Dialog data
      aiDialogVisible: false,
      // Share card data
      shareCardDialogVisible: false,
      shareCardData: null,
      sharingCard: false,
      recipientInfo: null,
      shareForm: {
        recipient_email: '',
        message: ''
      },
      shareRules: {
        recipient_email: [
          { required: true, message: 'Please enter recipient email', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }
        ]
      },
      searchQuery: ''
    }
  },
  watch: {
    viewMode(newMode) {
      localStorage.setItem('collectionViewMode', newMode)
    }
  },
  mounted() {
    this.$nextTick(() => {  // Ensure DOM is updated

      this.fetchMyPosts()
      this.fetchCreatedCollections()
      this.fetchBundles()
      this.fetchSubscriptionPrograms()
      this.fetchPrivateCards()

    })

    // Add keyboard event listener
    document.addEventListener('keydown', this.handleKeydown)
  },

  beforeDestroy() {
    // Remove keyboard event listener
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {


    handleTabClick(tab) {
      this.activeTab = tab.paneName
      localStorage.setItem('myKnowitsTab', tab.paneName)
    },

    async fetchCreatedCollections() {
      this.createdLoading = true
      try {
        const response = await postRequest('getMyPostCollections', {
          user_id: this.$store.state.user_id,
        })

        if (response.data.code === 0) {
          this.createdCollections = response.data.data
        } else {
          this.$message.error(response.data.msg || 'Failed to fetch created knowits')
        }
      } catch (error) {
        console.error('Error fetching created posts:', error)
        this.$message.error('Failed to fetch created knowits')
      } finally {
        this.createdLoading = false
      }
    },
    handleLike(postId) {
      console.log('Like post:', postId)
    },
    handleComment(postId) {
      console.log('Comment on post:', postId)
    },
    handleNewCollection() {
      localStorage.setItem('editCollectionId', '')
      this.$router.push('/new-collection')
    },
    async fetchBundles() {
      this.bundlesLoading = true
      try {
        const response = await postRequest('getMyCollectionBundles', {
          user_id: this.$store.state.user_id,
        })

        if (response.data.code === 0) {
          this.bundles = response.data.data
        } else {
          this.$message.error(response.data.msg || 'Failed to fetch bundles')
        }
      } catch (error) {
        console.error('Error fetching bundles:', error)
        this.$message.error('Failed to fetch bundles')
      } finally {
        this.bundlesLoading = false
      }
    },
    handleNewBundle() {
      localStorage.setItem('editBundleId', '')
      this.$router.push('/new-bundle')
    },
    handleBundleClick(bundle) {
      console.log('bundle:', bundle)
      this.$store.dispatch('setTempBundleId', bundle._id?.$oid || bundle._id?.$id || bundle.id)
      this.$router.push('/bundle')
    },
    fetchMyPosts() {
      // TODO: API call to get user's posts
      const params = {
        user_id: this.$store.state.user_id,
        time_stamp: Math.floor(Date.now() / 1000)
      }

      postRequest('getMyPosts', params).then(response => {
        if (response.data.code === 0) {
          this.myPosts = response.data.data
          this.posted = this.myPosts.filter(post => post.status === 'PUBLISHED')
          this.drafts = this.myPosts.filter(post => post.status === 'DRAFT' || post.status === 'PRIVATE')
        } else {
          this.$message.error(response.msg || 'Failed to fetch knowits')
        }
      }).catch(error => {
        console.error('Error fetching posts:', error)
        this.$message.error('Failed to fetch knowits')
      })


      // this.myPosts = [
      //   {
      //     id: 1,
      //     title: 'My Sample Cryptic',
      //     content: 'This is a cryptic I created...',
      //     authorName: this.$store.state.user_info.student_lastName + ' ' + this.$store.state.user_info.student_givenName,
      //     createdAt: new Date().toISOString(),
      //     likes: 5,
      //     comments: 2
      //   }
      // ]
    },
    goToNewKnowit() {
      localStorage.setItem('editPostId', '')
      this.$router.push('/new-knowit')
    },
    editDraft(draftId) {
      this.$router.push(`/edit-cryptic/${draftId}`)
    },
    selectGroup(groupValue) {
      this.selectedGroup = groupValue;
    },

    async fetchSubscriptionPrograms() {
      this.subscriptionLoading = true
      try {
        const response = await postRequest('getUserSubscriptionPrograms', {
          user_id: this.$store.state.user_id
        })

        if (response.data.code === 0) {
          this.subscriptionPrograms = response.data.data
        } else {
          this.$message.error(response.data.msg || 'Failed to fetch subscription programs')
        }
      } catch (error) {
        console.error('Error fetching subscription programs:', error)
        this.$message.error('Failed to fetch subscription programs')
      } finally {
        this.subscriptionLoading = false
      }
    },
    handleNewSubscription() {
      this.editingSubscription = null
      this.subscriptionForm = {
        name: '',
        description: '',
        usd_price: 1,
        status: 'active'
      }
      this.subscriptionDialogVisible = true
    },
    editSubscription(program) {
      this.editingSubscription = program
      this.subscriptionForm = {
        name: program.name,
        description: program.description,
        usd_price: program.usd_price,
        status: program.status
      }
      this.subscriptionDialogVisible = true
    },
    async submitSubscription() {
      this.$refs.subscriptionForm.validate(async (valid) => {
        if (!valid) return

        this.submitting = true
        try {
          const params = {
            id: this.editingSubscription?._id?.$oid || this.editingSubscription?._id?.$id || '',
            user_id: this.$store.state.user_id,
            ...this.subscriptionForm
          }

          const response = await postRequest('updateUserSubscriptionProgram', params)

          if (response.data.code === 0) {
            this.$message.success('Subscription program saved successfully')
            this.subscriptionDialogVisible = false
            this.fetchSubscriptionPrograms()
          } else {
            this.$message.error(response.data.msg || 'Failed to save subscription program')
          }
        } catch (error) {
          console.error('Error saving subscription program:', error)
          this.$message.error('Failed to save subscription program')
        } finally {
          this.submitting = false
        }
      })
    },
    updatePostGroup({ post, group }) {
      // This method is kept for compatibility but won't be used without groups
      console.log('Group functionality has been removed');
    },
    selectGroup(groupValue) {
      this.selectedGroup = groupValue;
    },
    showLoginDialog() {
      // Implement the logic to show the login dialog
      console.log('Login required');
      this.loginDialogVisible = true;
    },
    handleLoginSuccess() {
      // Implement the logic to handle login success
      console.log('Login successful');
      this.loginDialogVisible = false;
    },
    handleAuthDialogClose(visible) {
      this.loginDialogVisible = visible
    },
    goToCollection(collectionId) {
      this.$store.dispatch('setTempCollectionId', collectionId)
      this.$router.push({ path: '/deck', query: { id: collectionId } })
    },

    // Private Cards methods
    async fetchPrivateCards() {
      this.privateCardsLoading = true
      try {
        const response = await postRequest('getMyCards', {
          user_id: this.$store.state.user_id
        })

        if (response.data.code === 0) {
          this.privateCards = response.data.data || []
        } else {
          console.error('Failed to fetch private cards:', response.data.msg)
        }
      } catch (error) {
        console.error('Error fetching private cards:', error)
        this.$message.error('Failed to load private cards')
      } finally {
        this.privateCardsLoading = false
      }
    },

    viewCard(card) {
      // Handle card view logic if needed
      console.log('Viewing card:', card)
    },

    async saveCard(cardData) {
      this.privateCardsLoading = true
      try {
        const isEditing = cardData.id && cardData.id !== ''
        const response = await postRequest('updateCard', {
          user_id: this.$store.state.user_id,
          card_data: cardData,
          is_edit: isEditing
        })

        if (response.data.code === 0) {
          this.$message.success(isEditing ? 'Card updated successfully' : 'Card created successfully')
          await this.fetchPrivateCards() // Refresh the cards list
        } else {
          this.$message.error(response.data.msg || 'Failed to save card')
          this.privateCardsLoading = false
        }
      } catch (error) {
        console.error('Error saving card:', error)
        this.$message.error('Failed to save card')
        this.privateCardsLoading = false
      }
    },

    async deleteCard(card) {
      this.$confirm('Are you sure you want to delete this card?', 'Confirm Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        this.privateCardsLoading = true
        try {
          const response = await postRequest('deleteCard', {
            user_id: this.$store.state.user_id,
            card_id: card.id
          })

          if (response.data.code === 0) {
            this.$message.success('Card deleted successfully')
            await this.fetchPrivateCards() // Refresh the cards list
          } else {
            this.$message.error(response.data.msg || 'Failed to delete card')
            this.privateCardsLoading = false
          }
        } catch (error) {
          console.error('Error deleting card:', error)
          this.$message.error('Failed to delete card')
          this.privateCardsLoading = false
        }
      }).catch(() => {
        this.$message.info('Delete cancelled')
      })
    },
    
    // Handle successful deletion from SimpleCardView or other card components
    async handleDeleteSuccess(cardId) {
      console.log('Card deleted successfully, refreshing data. Card ID:', cardId);
      
      // Remove the card from local array immediately for better UX
      if (this.privateCards && this.privateCards.length > 0) {
        const index = this.privateCards.findIndex(card => card.id === cardId);
        if (index > -1) {
          this.privateCards.splice(index, 1);
        }
      }
      
      // Refresh collections to update card counts
      await this.fetchCreatedCollections();
      
      // Optionally refresh private cards if they're being displayed somewhere
      if (this.privateCards && this.privateCards.length > 0) {
        await this.fetchPrivateCards();
      }
    },

    // AI Dialog methods
    toggleAIDialog() {
      this.aiDialogVisible = !this.aiDialogVisible
    },

    handleKeydown(event) {
      // Check for Command+L (Mac) or Ctrl+L (Windows/Linux)
      if ((event.metaKey || event.ctrlKey) && event.key === 'l') {
        event.preventDefault()
        this.toggleAIDialog()
      }
    },

    // Context pot methods
    addToContextPot(item) {
      this.$store.dispatch('contextPot/toggleItem', item).then(result => {
        if (result.success) {
          if (result.action === 'added') {
            this.$message.success('Added to context pot');
          } else {
            this.$message.info('Removed from context pot');
          }
        }
      });
    },

    clearContextPot() {
      this.$store.dispatch('contextPot/clearAll').then(result => {
        if (result.success) {
          this.$message.success(result.message);
        }
      });
    },

    removeFromContextPot(index) {
      this.$store.dispatch('contextPot/removeItem', index).then(result => {
        if (result.success) {
          this.$message.info(result.message);
        }
      });
    },

    // Share card methods
    handleShareCard(card) {
      this.shareCardData = card
      this.shareForm = {
        recipient_email: '',
        message: ''
      }
      this.recipientInfo = null
      this.shareCardDialogVisible = true
    },

    async validateRecipient() {
      if (!this.shareForm.recipient_email || !this.shareForm.recipient_email.includes('@')) {
        this.recipientInfo = null
        return
      }

      try {
        const response = await postRequest('getUserByEmail', {
          email: this.shareForm.recipient_email
        })

        if (response.data.code === 0 && response.data.data) {
          this.recipientInfo = response.data.data
        } else {
          this.recipientInfo = { email: this.shareForm.recipient_email }
          this.$message.info('User not found. Card will be shared via email.')
        }
      } catch (error) {
        console.error('Error validating recipient:', error)
        this.recipientInfo = { email: this.shareForm.recipient_email }
      }
    },

    async confirmShareCard() {
      this.$refs.shareForm.validate(async (valid) => {
        if (!valid) return

        this.sharingCard = true
        try {
          // Clean card data to remove MongoDB-incompatible fields
          const cleanCardData = { ...this.shareCardData }
          // Extract ID from MongoDB format if present
          if (cleanCardData._id) {
            if (typeof cleanCardData._id === 'object') {
              cleanCardData.original_id = cleanCardData._id.$oid || cleanCardData._id.$id
              delete cleanCardData._id
            }
          }

          const response = await postRequest('shareCardToUser', {
            user_id: this.$store.state.user_id,
            card_id: this.shareCardData.id,
            recipient_email: this.shareForm.recipient_email,
            message: this.shareForm.message,
            card_data: cleanCardData // Include full card data for duplication
          })

          if (response.data.code === 0) {
            this.$message.success('Card shared successfully!')
            this.shareCardDialogVisible = false
          } else {
            this.$message.error(response.data.msg || 'Failed to share card')
          }
        } catch (error) {
          console.error('Error sharing card:', error)
          this.$message.error('Failed to share card')
        } finally {
          this.sharingCard = false
        }
      })
    },

    truncateText(text, maxLength) {
      if (!text) return ''
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    },
    handleSearch() {
      // The search is reactive through computed properties, so this is just for UX feedback
      if (this.searchQuery) {
        this.$message.info(`Searching for: ${this.searchQuery}`)
      }
    }
  },
  computed: {
    creator_functionality_level() {
      return this.$store.state.user_info.creator_functionality_level || 'Basic';
    },
    globalContextPot() {
      return this.$store.state.contextPot.items;
    },
    filteredDrafts() {
      if (!this.selectedGroup) {
        return this.drafts;
      }
      return this.drafts.filter(draft => draft.group === this.selectedGroup.label);
    },
    filteredPosts() {
      if (this.selectedGroup === 'all') {
        return [...this.drafts, ...this.posted];
      } else if (this.selectedGroup === 'private') {
        return this.drafts;
      } else if (this.selectedGroup === 'public') {
        return this.posted;
      }
      return [];
    },
    emptyStateMessage() {
      if (this.selectedGroup === 'all') {
        return 'No posts found.';
      } else if (this.selectedGroup === 'private') {
        return 'No unlisted posts found.';
      } else if (this.selectedGroup === 'public') {
        return 'You do not have any public posts yet.';
      }
      return 'No posts found.';
    },
    emptyStacksMessage() {
      if (this.selectedGroup === 'all') {
        return 'No stacks found.';
      } else if (this.selectedGroup === 'private') {
        return 'No unlisted stacks found.';
      } else if (this.selectedGroup === 'public') {
        return 'You do not have any public stacks yet.';
      }
      return 'No stacks found.';
    },
    safeKnowitGroups() {
      // Return empty array since groups are removed
      return []
    },
    searchFilteredPosts() {
      if (!this.searchQuery) {
        return this.filteredPosts;
      }
      const query = this.searchQuery.toLowerCase();
      return this.filteredPosts.filter(post => {
        return (post.title && post.title.toLowerCase().includes(query)) ||
               (post.content && post.content.toLowerCase().includes(query))
      });
    },
    searchFilteredCollections() {
      if (!this.searchQuery) {
        return this.createdCollections;
      }
      const query = this.searchQuery.toLowerCase();
      return this.createdCollections.filter(collection => {
        return (collection.title && collection.title.toLowerCase().includes(query)) ||
               (collection.description && collection.description.toLowerCase().includes(query))
      });
    },
    searchFilteredBundles() {
      if (!this.searchQuery) {
        return this.bundles;
      }
      const query = this.searchQuery.toLowerCase();
      return this.bundles.filter(bundle => {
        return (bundle.title && bundle.title.toLowerCase().includes(query)) ||
               (bundle.description && bundle.description.toLowerCase().includes(query))
      });
    }
  }
}
</script>

<style scoped>
.my-collection-container {
  width: 100%;
  max-width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: #f5f7fa;
  padding: 0;
  overflow-x: hidden;
}

.custom-header {
  background-color: #409EFF;
  color: white;
  padding-left: 20px;
  width: 100%;
  height: 64px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.el-main {
  padding: 20px;
  width: 100%;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.my-collection-container {
  height: calc(100vh - 64px);
  /* Adjust 64px based on your header height */
  display: flex;
  flex-direction: column;

}

.tabs-header {
  flex-shrink: 0;
  border-bottom: 1px solid #e4e7ed;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.posts-container {
  width: 100%;
  max-width: 100%;
  padding: 0 20px;
  margin: 0 auto;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.grid-item {
  width: 100%;
  height: 100%;
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #909399;
}

.empty-state p {
  margin-bottom: 20px;
}

.tabs-header {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 0;
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
}

.section-title {
  margin: 0;
  white-space: nowrap;
}

.demo-tabs {
  background: white;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}

.el-tabs__content {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 10px 20px;
  /* Reduced padding from 20px to 10px vertical */
  height: 100%;
}

.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-right: 20px;
}

.view-mode-selector {
  margin-left: auto;
  margin-right: 20px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(400px, 100%), 1fr));
  gap: 20px;
  padding: 20px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.list-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.tabs-container {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
}

.content-container {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

/* Ensure tabs don't scroll */
:deep(.el-tabs__header) {
  margin: 0;
}

:deep(.el-tabs__nav-wrap) {
  padding: 0 20px;
}

.tab-container {
  display: flex;
  flex-direction: row;
  gap: 24px;
  height: calc(100vh - 200px);
  padding: 0;
  margin: 5px;
  
}

.left-menu {
  width: 240px;
  height: 100%;
  background: #fafafa;
  border-radius: 8px;
  padding: 16px;
  flex-shrink: 0;
  border: 1px solid #e4e7ed;
}

.menu-item {
  margin-bottom: 4px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.menu-item.active {
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}

.menu-item-content {
  width: 100%;
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}

.menu-item-content:hover {
  background-color: #f0f9ff;
}

.menu-item.active .menu-item-content {
  background-color: #e6f7ff;
}

.group-name {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  flex: 1;
  margin-right: 8px;
}

.menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e4e7ed;
}

.menu-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.menu-header .el-button {
  padding: 4px 8px;
  font-size: 12px;
  color: #409eff;
}

.menu-header .el-button:hover {
  color: #66b1ff;
  background-color: #ecf5ff;
}

.menu-items {
  margin-top: 8px;
}

.menu-item:nth-child(3) {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;
}


.group-menu-btn {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 2px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  opacity: 0.6;
}

.group-menu-btn:hover {
  background-color: #e4e7ed;
  opacity: 1;
}

.group-menu-btn i {
  transform: rotate(90deg);
  font-size: 16px;
  color: #909399;
}

/* Posts container styling */
.posts-container {
  flex: 1;
  padding: 0;
  margin: 0;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* Posts specific styles for My Posts tab */
.tab-container .posts-container {
  border: 1px solid #e4e7ed;
}

/* New simplified posts tab styles */
.posts-tab-container {
  width: 100%;
  padding: 20px;
}

.posts-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;
}

.search-controls {
  display: flex;
  align-items: center;
}

.filter-widget {
  display: flex;
  align-items: center;
}

.posts-grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  width: 100%;
  margin-bottom: 20px;
}

.posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(320px, 100%), 1fr));
  gap: 20px;
  padding: 20px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.grid-item {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.grid-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.empty-state p {
  margin-bottom: 24px;
  font-size: 16px;
  color: #606266;
}

.empty-state .el-button {
  padding: 12px 24px;
  font-size: 14px;
  border-radius: 6px;
}

/* Input styling for editing groups */
.menu-item-content .el-input {
  margin: 0;
}

.menu-item-content .el-input__inner {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  box-shadow: none;
}

.menu-item-content .el-input__inner:focus {
  border: none;
  box-shadow: none;
  background: white;
  border-radius: 4px;
  padding: 2px 4px;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .posts-grid {
    grid-template-columns: repeat(auto-fill, minmax(min(280px, calc(100% - 40px)), 1fr));
    gap: 16px;
    padding: 16px;
  }
  
  .grid-container {
    grid-template-columns: repeat(auto-fill, minmax(min(350px, calc(100% - 40px)), 1fr));
  }
  
  .left-menu {
    width: 220px;
    padding: 12px;
  }
}

@media (max-width: 768px) {
  .tab-container {
    flex-direction: column;
    gap: 16px;
    height: auto;
  }
  
  .left-menu {
    width: 100%;
    height: auto;
    max-height: 200px;
    overflow-y: auto;
  }
  
  .posts-grid,
  .grid-container {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
  }
}

/* Subscription grid styles */
.subscription-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(300px, 100%), 1fr));
  gap: 20px;
  padding: 20px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.subscription-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.subscription-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subscription-header h3 {
  margin: 0;
  font-size: 18px;
  color: #303133;
}

.subscription-content {
  flex: 1;
}

.description {
  color: #606266;
  margin-bottom: 15px;
  line-height: 1.5;
}

.price-info {
  display: flex;
  align-items: baseline;
  gap: 5px;
}

.price {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.period {
  color: #909399;
}

.subscription-actions {
  display: flex;
  justify-content: flex-end;
}

/* Additional polish for the overall layout */
.tabs-header {
  border-bottom: 1px solid #e4e7ed;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

:deep(.el-tabs__item) {
  font-weight: 500;
  padding: 0 24px;
  height: 48px;
  line-height: 48px;
  transition: all 0.2s ease;
}

:deep(.el-tabs__item.is-active) {
  color: #409eff;
  font-weight: 600;
}

:deep(.el-tabs__active-bar) {
  background-color: #409eff;
  height: 3px;
}

:deep(.el-tabs__content) {
  padding: 0;
  background: #f5f7fa;
  min-height: calc(100vh - 200px);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* Improve the overall container spacing */
.my-collection-container {
  background: #f5f7fa;
  padding: 0;
}

/* Ensure proper spacing for the tab content */
:deep(.el-tab-pane) {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 200px);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* Mark Button Styles */
.mark-button {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: #409eff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  transition: all 0.3s ease;
  z-index: 1000;
  color: white;
  font-size: 20px;
}

.mark-button:hover {
  background: #66b1ff;
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
}

.mark-button:active {
  transform: translateY(-50%) scale(0.95);
}

/* AI Drawer Styles */
:deep(.ai-drawer .el-drawer__body) {
  padding: 0;
  height: 100%;
}

:deep(.ai-drawer) {
  z-index: 999;
}

/* Ensure drawer doesn't cover buttons */
.mark-button {
  z-index: 1001;
}

/* Share Card Dialog Styles */
.share-card-preview {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid #e4e7ed;
}

.share-card-preview h4 {
  margin: 0 0 12px 0;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.card-preview {
  background: white;
  border-radius: 6px;
  padding: 12px;
  border: 1px solid #ebeef5;
}

.card-preview .card-title {
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
}

.card-preview .card-content {
  color: #606266;
  font-size: 13px;
  line-height: 1.5;
}

.recipient-info {
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding: 8px 12px;
  background: #f0f9ff;
  border-radius: 4px;
  color: #409eff;
  font-size: 13px;
}

.recipient-info i {
  margin-right: 6px;
}

</style>